'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _abstractgraph = require('./abstractgraph');

var _abstractgraph2 = _interopRequireDefault(_abstractgraph);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _const = require('../const');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _debug2.default)('converseai-graphjs-align-center');

var CenterAlignGraph = function (_AbstractGraph) {
  _inherits(CenterAlignGraph, _AbstractGraph);

  function CenterAlignGraph() {
    _classCallCheck(this, CenterAlignGraph);

    return _possibleConstructorReturn(this, (CenterAlignGraph.__proto__ || Object.getPrototypeOf(CenterAlignGraph)).apply(this, arguments));
  }

  _createClass(CenterAlignGraph, [{
    key: 'loopLayersDown',
    value: function loopLayersDown(f) {
      _lodash2.default.each(this.layerArr, function (layer, layerIndex) {
        _lodash2.default.each(layer, function (nodeId, nodeIndex) {
          f({ layer: layer, nodeId: nodeId, layerIndex: layerIndex, nodeIndex: nodeIndex });
        });
      });
    }
  }, {
    key: 'loopLayersUp',
    value: function loopLayersUp(f) {
      _lodash2.default.eachRight(this.layerArr, function (layer, layerIndex) {
        _lodash2.default.eachRight(layer, function (nodeId, nodeIndex) {
          f({ layer: layer, nodeId: nodeId, layerIndex: layerIndex, nodeIndex: nodeIndex });
        });
      });
    }
  }, {
    key: 'setBasePosition',
    value: function setBasePosition(_ref) {
      var nodeId = _ref.nodeId,
          nodeIndex = _ref.nodeIndex,
          layerIndex = _ref.layerIndex;

      this.positionMap[nodeId] = [nodeIndex, layerIndex];
      debug(this.positionMap[nodeId]);
    }
  }, {
    key: 'setXPosition',
    value: function setXPosition(nodeId, position) {
      var layerIndex = this.layerMap[nodeId];
      var layer = this.layerArr[layerIndex];
      var i = layer.indexOf(nodeId);
      var leftX = layer[i - 1] && this.positionMap[layer[i - 1]] && this.positionMap[layer[i - 1]][0];
      var rightX = layer[i + 1] && this.positionMap[layer[i + 1]] && this.positionMap[layer[i + 1]][0];
      var currentX = this.positionMap[nodeId][0];

      if (position !== currentX) {
        // try preferred X position
        if (position < currentX && (leftX === undefined || leftX !== undefined && position - leftX >= 1)) {
          // wants to move left
          this.positionMap[nodeId][0] = position;
          this.movement = true;
          return;
        } else if (position > currentX && (rightX === undefined || rightX !== undefined && rightX - position >= 1)) {
          // wants to move right
          this.positionMap[nodeId][0] = position;
          this.movement = true;
          return;
        }

        if (this.isDummy(nodeId)) {
          // dummy nodes can push right-hand neighbours further right
          for (var index = i; index < layer.length; index++) {
            var id = layer[index];
            var modifier = index - i;
            this.positionMap[id][0] = position + modifier;
            this.movement = true;
          }
        } else {

          // try to move as close to the preferred X as possible
          var diff = position - currentX;
          if (diff > 0) {
            // move right
            if (currentX !== rightX - 1) {
              this.positionMap[nodeId][0] = rightX - 1;
              this.movement = true;
            }
            return;
          } else if (diff < 0) {
            // move left
            if (currentX !== leftX + 1) {
              this.positionMap[nodeId][0] = leftX + 1;
              this.movement = true;
            }
            return;
          }
        }
      }
    }
  }, {
    key: 'getXPosition',
    value: function getXPosition(_ref2) {
      var nodeId = _ref2.nodeId;

      var currentPos = this.positionMap[nodeId][0];
      var parentsOfNode = this.getFilteredParents(nodeId);
      var childrenOfNode = this.getFilteredChildren(nodeId);

      // if DUMMY, move to X of furthest right DUMMY or PARENT in chain
      if (this.isDummy(nodeId)) {
        return this.dummyChainLargestX(nodeId);
      }

      // if CHILD is DUMMY and CHILD is further right, move to CHILD's X
      if (this.hasDummyChild(nodeId)) {
        var childX = this.positionMap[childrenOfNode[0]][0];
        if (childX > currentPos) {
          return childX;
        } else {
          return currentPos;
        }
      }

      // if NODE, move to middle of PARENTS or CHILDREN, which ever has more 
      if (parentsOfNode.length > 1 || childrenOfNode.length > 1) {
        if (parentsOfNode.length > childrenOfNode.length) {
          return this.middleX(this.middleIDs(parentsOfNode));
        } else {
          return this.middleX(this.middleIDs(childrenOfNode));
        }
      }

      // if NODE is LEAF, move to first PARENT that either has SIBLINGS or multiple PARENTS
      if (childrenOfNode.length === 0) {
        var refNodeID = this.findReferenceAncestorID(nodeId);
        if (refNodeID) {
          return this.positionMap[refNodeID][0];
        } else {
          return currentPos;
        }
      }

      // If NODE's CHILD has multiple PARENTS, align NODE to it's PARENT
      var childId = childrenOfNode[0];
      var parentsOfChild = this.getFilteredParents(childId);
      if (parentsOfNode.length !== 0 && parentsOfChild.length > 1 && !this.hasDummyChild(childId)) {
        return this.middleX(this.middleIDs(parentsOfNode));
      }

      // default, align to child
      return this.positionMap[childrenOfNode[0]][0];
    }
  }, {
    key: 'getStraightenedPosition',
    value: function getStraightenedPosition(_ref3) {
      var nodeId = _ref3.nodeId;

      var currentPos = this.positionMap[nodeId][0];
      var parentsOfNode = this.getFilteredParents(nodeId);
      var childrenOfNode = this.getFilteredChildren(nodeId);

      // if 2 parents & 1 child, check for common X
      if (parentsOfNode.length === 2 & childrenOfNode.length === 1) {
        var parent1X = this.positionMap[parentsOfNode[0]][0];
        var parent2X = this.positionMap[parentsOfNode[1]][0];
        var childX = this.positionMap[childrenOfNode[0]][0];

        if (childX >= parent1X && childX <= parent2X) {
          return childX;
        } else {
          return currentPos;
        }
      }

      // if 1 parent & 2 children, check for common X
      if (parentsOfNode.length === 1 & childrenOfNode.length === 2) {
        var child1X = this.positionMap[childrenOfNode[0]][0];
        var child2X = this.positionMap[childrenOfNode[1]][0];
        var parentX = this.positionMap[parentsOfNode[0]][0];

        if (parentX >= child1X && parentX <= child2X) {
          return parentX;
        } else {
          return currentPos;
        }
      }

      return currentPos;
    }

    // reference node is a node that has siblings or multiple parents

  }, {
    key: 'findReferenceAncestorID',
    value: function findReferenceAncestorID(nodeId) {
      var currentID = nodeId;
      do {
        // get parent id
        currentID = this.getFilteredParents(currentID)[0];
        if (currentID && this.isReferenceNode(currentID)) {
          return currentID;
        }
      } while (currentID);
      return null;
    }

    // reference node is a node that has siblings or multiple parents

  }, {
    key: 'isReferenceNode',
    value: function isReferenceNode(nodeId) {
      var parentsOfNode = this.getFilteredParents(nodeId);

      if (parentsOfNode.length === 0) return false;else if (parentsOfNode.length > 1) return true;else {
        // check for siblings
        var parentID = parentsOfNode[0];
        var childrenOfParent = this.downwardsMap[parentID];
        return childrenOfParent.length > 1;
      }
    }

    /* filter out loops from parents */

  }, {
    key: 'getFilteredParents',
    value: function getFilteredParents(nodeId) {
      var _this2 = this;

      var parentIDs = this.upwardsMap[nodeId] || [];

      return parentIDs.filter(function (id) {
        var nodeLayer = _this2.layerMap[nodeId];
        var parentLayer = _this2.layerMap[id];
        if (parentLayer < nodeLayer) {
          return id;
        }
      });
    }

    /* filter out loops from children */

  }, {
    key: 'getFilteredChildren',
    value: function getFilteredChildren(nodeId) {
      var _this3 = this;

      var childrenIDs = this.downwardsMap[nodeId] || [];

      return childrenIDs.filter(function (id) {
        var nodeLayer = _this3.layerMap[nodeId];
        var childLayer = _this3.layerMap[id];
        if (childLayer > nodeLayer) {
          return id;
        }
      });
    }
  }, {
    key: 'isDummy',
    value: function isDummy(nodeId) {
      return ('' + nodeId).startsWith('D');
    }
  }, {
    key: 'hasDummyChild',
    value: function hasDummyChild(nodeId) {
      var childIDs = this.downwardsMap[nodeId] || [];
      if (childIDs.length !== 1) {
        return false;
      } else {
        return this.isDummy(childIDs[0]);
      }
    }

    // includes first non-dummy parent node

  }, {
    key: 'dummyChainLargestX',
    value: function dummyChainLargestX(nodeId) {
      var largestX = this.positionMap[nodeId][0];

      var currentID = nodeId;
      do {
        var nextLayer = this.upwardsMap[currentID];
        currentID = nextLayer && nextLayer[0];
        var currentX = currentID && this.positionMap[currentID][0];
        if (currentX > largestX) {
          largestX = currentX;
        }
      } while (this.isDummy(currentID));

      currentID = nodeId;
      while (this.isDummy(currentID)) {
        var _nextLayer = this.downwardsMap[currentID];
        currentID = _nextLayer && _nextLayer[0];
        var _currentX = currentID && this.positionMap[currentID][0];
        if (this.isDummy(currentID) && _currentX > largestX) {
          largestX = _currentX;
        }
      };
      return largestX;
    }
  }, {
    key: 'middleIDs',
    value: function middleIDs(ids) {
      var middleIndex = (ids.length - 1) / 2.0;
      var middleIDs = [];
      if (ids.length % 2 === 0) {
        middleIDs.push(ids[Math.floor(middleIndex)]);
        middleIDs.push(ids[Math.ceil(middleIndex)]);
      } else {
        middleIDs.push(ids[Math.floor(middleIndex)]);
      }
      return middleIDs;
    }
  }, {
    key: 'middleX',
    value: function middleX(ids) {
      var _this4 = this;

      return _lodash2.default.chain(ids).map(function (id) {
        return _this4.positionMap[id][0];
      }).mean().value();
    }
  }, {
    key: 'alignment',
    get: function get() {
      return _const.ALIGN_CENTER;
    }
  }]);

  return CenterAlignGraph;
}(_abstractgraph2.default);

exports.default = CenterAlignGraph;
module.exports = exports['default'];